import { useEffect } from "react";
import useSelected from "../useSelected";

export default ({ items, initial }) => {
	const initialSplitted = String(initial).split(/[,\/-]/);
	const matchFromUrl = initial
		? items.filter(
				item =>
					initialSplitted.includes(item.meta.url) ||
					initialSplitted.includes(item.meta.urlValue)
		  )
		: [];

	const { selected, check, setSelected, reset, hasSelected } = useSelected(
		items.map(item => item.value),
		matchFromUrl.map(item => item.value)
	);
	// eslint-disable-next-line
  useEffect(reset, [initial]);
	return {
		matchFromUrl,
		selected,
		check,
		setSelected,
		reset,
		isSelected: hasSelected,
	};
};
